import {find} from 'lodash';

import {api} from '@utils/api';

export const getAllCharities = async (session, user, gc) => {
	try {
		const charities = await api(
			{
				url: `/user/charities`,
				method: 'POST',
			},
			session,
		);

		return filteredCharityData(charities, user, gc);
	} catch (e) {
		return [];
	}
};

export const filteredCharityData = async (charities, user, gc) => {
	try {
		const charityData = {
			charities: [],
			userCharityId: '',
			goodCauseName: null,
			goodCauseImage: null,
			goodCauseMessage: false,
			Parentcharityid: '',
		};
		if (charities && charities.charity && charities.charity.length) {
			charityData.userCharityId = user ? gc?._id : '';
			if (charityData.userCharityId) {
				let charityDataValue = find(charities.charity, {
					_id: charityData.userCharityId,
				});
				if (charityDataValue) {
					charityData.goodCauseName = charityDataValue.registeredCharityName;
					charityData.goodCauseImage = charityDataValue.charityLogo;
					charityData.Parentcharityid = user ? gc?._id : '';
				} else {
					charityData.Parentcharityid = '';
				}
			}

			charityData.goodCauseMessage = user?.is_updated_good_cause;
			charityData.state = user.state_name_id ? user.state_name_id : '';
			charityData.charities = charities.charity ? charities.charity : [];
		}
		return charityData ? charityData : [];
	} catch (e) {
		return [];
	}
};
